module.exports = __webpack_public_path__ + "img/desktop/Menus-betmenu/btn-paytable-up@2x.png?1.0.17";